<div class="container-fluid wrapper primary-background">
  <div class="row" *ngIf="!crossSell">
    <div class="col-12 title">
      <h3>Added To Your Cart</h3>
    </div>
  </div>

  <!-- CART ITEM (without cross sell) -->
  <div class="row" *ngIf="cartItem && !crossSell">
    <div class="col-12">
      <h6>{{ cartItem.artistName }}</h6>
      <h5>{{ cartItem.name }}</h5>
    </div>
    <div class="col-12" *ngIf="!cartItem.subnames.length">
      {{ cartItem.format }}
    </div>
    <div class="item-subname col-12" *ngFor="let subName of cartItem.subnames">
      {{ subName.substring(0, subName.indexOf('(')) }}
    </div>

    <!-- IMAGE -->
    <div class="col-12">
      <div class="image">
        <img [src]="cartItem.photo.thumbnail_url" />
      </div>
    </div>
  </div>

  <!-- CART ITEM (with cross sell) -->
  <div class="row bought-item" *ngIf="cartItem && crossSell">
    <div class="col-12 bundle-and-save" *ngIf="crossSell"><strong>Added to Your Cart</strong></div>

    <div class="col-3">
      <!-- PHOTO -->
      <div class="image">
        <img [src]="cartItem.photo.thumbnail_url" />
      </div>
    </div>

    <div class="col-7">
      <div class="item-name">
        <div>{{ cartItem.artistName }}</div>
        <div>{{ cartItem.name }}</div>
        <div>{{ cartItem.type }}</div>
      </div>
    </div>
  </div>

  <!-- Buttons -->
  <div class="row button-row-wrapper">
    <div class="col-6 button-wrapper">
      <div class="pv-button" [routerLink]="['/cart']" (click)="onClose.emit()">
        View Cart
      </div>
    </div>
    <div class="col-6 button-wrapper">
      <div
        class="pv-button"
        [routerLink]="['/cart', 'checkout']"
        (click)="onClose.emit()"
      >
        Checkout
      </div>
    </div>
    <div class="col-12 button-wrapper">
      <div class="pv-button warn" (click)="onClose.emit()">Keep Shopping</div>
    </div>
  </div>

  <!-- BUNDLE CROSS SELL -->
  <div class="row cross-sell" *ngIf="cartItem && crossSell">
    <div class="col-12 bundle-and-save"><strong>Want to Bundle this Item & Save?</strong></div>

    <div class="col-3">
      <!-- PHOTO -->
      <div class="image">
        <img [src]="crossSell.img" />
      </div>
    </div>
    <div class="col-7">
      <!-- Name -->
      <div class="item-name">
        <div>{{ cartItem.artistName }}</div>
        <div>{{ crossSell.title }}</div>
      </div>
    </div>
    <div class="col-12 cross-sell-button">
      <div
        class="pv-button"
        [routerLink]="crossSell.url"
        [queryParams]="{ selected: cartItem.instanceId }"
        (click)="onClose.emit()"
      >
        Complete Your Bundle
      </div>
    </div>
  </div>
</div>
